/**
 * Detalle de planes para UI — proyección SSOT vía planTiers.
 * Orden: POS-PLANS-SSOT-001B-CLOSURE-001
 */

import {
  normalizeLicensePlan,
  PLAN_LABELS_ES,
  PLAN_TIERS,
  PLAN_COMMERCIAL_META,
  getModulePresetForPlan as getModulePresetForPlanFromTiers
} from './planTiers';
import {
  MODULE_KEYS,
  MODULE_LABELS_ES
} from '../config/modulesCatalog';

export { MODULE_KEYS, MODULE_LABELS_ES };

export function getModulePresetForPlan(rawPlan) {
  return getModulePresetForPlanFromTiers(rawPlan);
}

export const PLAN_IDS = PLAN_TIERS;

const ACCESS_POLICY = "Sesión única por usuario. Sesiones concurrentes de la empresa hasta el cupo de usuarios activos del plan.";

export const PLAN_COMMERCIAL_META_ES = {
  basic: {
    includedUsers: PLAN_COMMERCIAL_META.basic.includedUsers,
    includedBranches: PLAN_COMMERCIAL_META.basic.includedBranches,
    extraUserArs: PLAN_COMMERCIAL_META.basic.extraUserArs,
    extraBranchArs: PLAN_COMMERCIAL_META.basic.extraBranchArs,
    accessPolicy: ACCESS_POLICY
  },
  intermediate: {
    includedUsers: PLAN_COMMERCIAL_META.intermediate.includedUsers,
    includedBranches: PLAN_COMMERCIAL_META.intermediate.includedBranches,
    extraUserArs: PLAN_COMMERCIAL_META.intermediate.extraUserArs,
    extraBranchArs: PLAN_COMMERCIAL_META.intermediate.extraBranchArs,
    accessPolicy: ACCESS_POLICY
  },
  premium: {
    includedUsers: PLAN_COMMERCIAL_META.premium.includedUsers,
    includedBranches: PLAN_COMMERCIAL_META.premium.includedBranches,
    extraUserArs: PLAN_COMMERCIAL_META.premium.extraUserArs,
    extraBranchArs: PLAN_COMMERCIAL_META.premium.extraBranchArs,
    accessPolicy: ACCESS_POLICY
  }
};

/** Textos orientativos por plan (marketing / instructivo) */
export const PLAN_DEEP_COPY_ES = {
  basic: {
    tagline: 'Operación diaria esencial',
    pitch:
      'Pensado para comercios que venden en mostrador y controlan stock sin necesidad de compras formales ni listas avanzadas.',
    advantages: [
      'Punto de venta y stock para seguir el día a día sin fricción',
      'Clientes y ventas para facturar y consultar historial',
      'Menor superficie de menú: menos distracciones para el equipo'
    ],
    highlight: 'Ideal para mostrador único o despensa que prioriza velocidad de cobro.',
    commercial:
      'Incluye hasta 2 usuarios y 1 sucursal; podés sumar usuarios/sucursales adicionales cuando tu operación crezca.'
  },
  intermediate: {
    tagline: 'Negocio completo sin industrial',
    pitch:
      'La opción equilibrada: compras, proveedores, listas de precios y transferencias entre locales, sin módulos de producción ni flota.',
    advantages: [
      'Compras y proveedores para abastecer con trazabilidad',
      'Listas de precios y transferencias para multi-sucursal',
      'Reportes y caja alineados al volumen medio de operación'
    ],
    highlight: 'Recomendada para distribuidoras y cadenas chicas que ya gestionan reposición y varios puntos.',
    commercial:
      'Incluye hasta 6 usuarios y 3 sucursales con opción de ampliar por adicionales.'
  },
  premium: {
    tagline: 'Todo el sistema, sin techo',
    pitch:
      'Acceso completo a producción, recetas, materias primas, auditoría, vehículos y promociones cuando el negocio escala.',
    advantages: [
      'Producción, recetas y materias primas para fabricación o cocina central',
      'Auditoría y trazabilidad para equipos más grandes',
      'Promociones y flota cuando el modelo de negocio lo requiere'
    ],
    highlight: 'Pensada para operaciones que industrializan, auditan o integran logística propia.',
    commercial:
      'Incluye hasta 15 usuarios y 10 sucursales; ideal para equipos grandes y multi-local.'
  }
};

export function countEnabledModules(preset) {
  return MODULE_KEYS.filter((k) => preset[k]).length;
}

export function planLabel(planId) {
  return PLAN_LABELS_ES[normalizeLicensePlan(planId)] || planId;
}
